import * as actionTypes from '../actions/actionTypes'
import {
  crudInitialState,
  itemLoad,
  itemLoaded,
  itemsLoadedAll,
  itemLoadFailed,
  itemSave,
  itemSavedCache,
  itemSaveFailed,
  itemsLoad,
  itemsLoaded,
  itemsLoadFailed,
  itemsChangeSortOrder,
  itemDelete,
  itemDeleted,
  itemDeleteFailed,
  itemsOrder,
} from './crud'

const initialState = crudInitialState

const actionHandlers = {
  [actionTypes.INSTITUTIONS_LOAD]: itemsLoad,
  [actionTypes.INSTITUTIONS_LOADED]: itemsLoaded,
  [actionTypes.INSTITUTIONS_LOADED_ALL]: itemsLoadedAll,
  [actionTypes.INSTITUTIONS_LOAD_FAILED]: itemsLoadFailed,
  [actionTypes.INSTITUTION_LOAD]: itemLoad,
  [actionTypes.INSTITUTION_LOADED]: itemLoaded,
  [actionTypes.INSTITUTION_LOAD_FAILED]: itemLoadFailed,
  [actionTypes.INSTITUTION_UPDATE]: itemSave,
  [actionTypes.INSTITUTION_CREATE]: itemSave,
  [actionTypes.INSTITUTION_UPDATED]: itemSavedCache,
  [actionTypes.INSTITUTION_CREATED]: itemSavedCache,
  [actionTypes.INSTITUTION_UPDATE_FAILED]: itemSaveFailed,
  [actionTypes.INSTITUTION_CREATE_FAILED]: itemSaveFailed,
  [actionTypes.INSTITUTIONS_CHANGE_SORT_ORDER]: itemsChangeSortOrder,
  [actionTypes.INSTITUTIONS_ORDER]: itemsOrder,
  [actionTypes.INSTITUTION_DELETE]: itemDelete,
  [actionTypes.INSTITUTION_DELETED]: itemDeleted,
  [actionTypes.INSTITUTION_DELETE_FAILED]: itemDeleteFailed,
}

export default (state = initialState, { type, payload }) => {
  const handler = actionHandlers[type]
  return handler ? handler(state, payload) : state
}
